<template>
  <div>
    <slot
      :error="error"
      :deleteServerError="deleteServerError"
    />
  </div>
</template>

<script>
import dataMixin from "@/mixins/data-mixin";
import clone from "lodash/clone";

export default {
  name: "ValidationField",
  props: {
    uuid: String,
    propPath: String,
    formRef: String,
    showUserMessageError: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    dataMixin('errors', 'transientData.serversideErrors', {}),
  ],
  data() {
    return {

    };
  },
  computed: {
    error() {
      if (this.showUserMessageError && this.errors?.userMessage !== undefined) {
        return [this.errors.userMessage];
      }
      return this.errors?.fieldErrors?.[this.uuid]?.[this.propPath];
    },
  },
  methods: {
    deleteServerError() {
      let objClone = clone(this.errors, true);
      if (this?.errors?.userMessage) {
        delete objClone.userMessage;
        this.errors = objClone;
      } else if (this?.errors?.fieldErrors?.[this.uuid]?.[this.propPath] !== undefined) {
        if (Object.keys(this.errors.fieldErrors[this.uuid]).length === 1) {
          delete objClone.fieldErrors[this.uuid];
        } else {
          delete objClone.fieldErrors[this.uuid][this.propPath];
        }
        this.errors = objClone;
      }
    },
  },
}
</script>

